import { useContext, useEffect } from 'react';
import { baseFontList, BaseFontType } from '../../../constants/font.constant';
import { FontInjectedContext } from '../../../context/font/FontInjectedContext';
import { IViewFontProps } from '../../../hook/brand/useViewFont';
import { convertBrandFont, convertBrandFontList, findBaseFontByServerName } from '../../../util/font.utils';
import { isOnOff } from '../../../constants/common';

const useFontInjectedContext = (viewFontProps?: IViewFontProps) => {
  const { setFontList, setBrandFont } = useContext(FontInjectedContext);

  const { brandFontList: data } = viewFontProps || {};

  useEffect(() => {
    if (!data) return;
    const { defaultType, brandFontFileList } = data;
    const brandFontList = convertBrandFontList(brandFontFileList);
    setFontList([...brandFontList.reverse(), ...baseFontList]);
    // 선택된 폰트 설정
    if (defaultType === 'CUSTOM') {
      const toggledBrandFontFile = brandFontFileList.find((font) => isOnOff(font.defaultToggle));
      if (toggledBrandFontFile) {
        setBrandFont(convertBrandFont(toggledBrandFontFile));
      }
    } else {
      setBrandFont(findBaseFontByServerName(defaultType as BaseFontType));
    }
  }, [data, setFontList, setBrandFont]);
};

export default useFontInjectedContext;
